import {start} from '@stubhub/speedy-react-renderer';
// option for @stubhub/speedy-react-renderer to define a global Layout
import Layout from './layout';
// option for @stubhub/speedy-react-renderer to obtain routes definition
import getRoutes from './routes';

export function render() {
  return start({
    layout: Layout,
    getRoutes
  });
}
